export function getToken() {
  return localStorage.getItem('molv_token');
}

export function setToken(token) {
  localStorage.setItem('molv_token', token);
}

export function removeToken() {
  localStorage.removeItem('molv_token');
}
